export const queries = {
  user: "/v1/users/self/",
  batches: "/v1/hub/pickupbatches/",
  auth: {
    signin: "/v1/auth/signin/",
    signout: "/v1/auth/signout/",
    token: {
      verify: "/v1/auth/token/verify/",
      refresh: "/v1/auth/token/refresh/",
    },
  },
  plan: {
    long: "/v1/hub/cluster_plans/long/",
    short: "/v1/hub/cluster_plans/",
    merge: (id: number) => `/v1/hub/cluster_plans/${id}/merge/`,
    shift: "/v1/hub/cluster_plans/items/update/",
    create: `/v1/hub/cluster_plans/items/recreate/`,
  }, location: {
    coordinate: "/sectors/coordinates",
    zipcode: "/zipcodes/coordinates",
    sectors: "/v1/location/sectors/",
  }, shipping: {
    list: "/v2/hub/shippingitems/",
    sectors: "/v2/hub/shippingitems/sectors/",
  }, shop: {
    list: "/v1/shop/shops/"
  }
};
